import { mods } from '@approvalmax/theme';
import { oDropdownPanel, TransparentButton } from '@approvalmax/ui';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

export const DropdownActivatorRoot = styled.div`
    position: relative;
`;

export const Panel = styled.div<StyledMods<{ fullWidth: boolean }>>`
    ${oDropdownPanel()}
    display: flex;
    flex-flow: column;
    padding: 16px;
    max-width: 300px;

    ${mods('fullWidth', true)`
        max-width: 700px;
    `};
`;

export const IconButton = styled(TransparentButton)<StyledMods<{ forDropDown?: boolean }>>`
    ${mods('forDropDown', true)`
         position: absolute;
         z-index: 1;
         top: calc(50% - 10px);
         right: 5px;
         background: white;
         cursor: pointer;
         height: 18px;
    `};
`;

export const Gradient = styled.div`
    position: absolute;
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 69%);
    right: 21px;
    top: 1px;
    bottom: 1px;
    width: 10px;
`;
